import { Box } from '@osmosis/tailwind-ui/components/Box';
import React from 'react';

type Props = {
  hasError?: boolean;
  htmlFor: string;
  content: React.ReactNode;
  className?: string;
};

/**
 * Used for input label.
 */
const InputLabel = (props: Props) => {
  const { hasError, content, htmlFor, className = '' } = props;
  return (
    <Box className={`mb-1`}>
      <label
        className={`${
          hasError ? 'text-red-600 font-[700]' : 'text-gray-800 font-[700]'
        } ${hasError ? 'opacity-[100]' : 'opacity-[0.75]'} ${className}`}
        htmlFor={htmlFor}
      >
        {content}
      </label>
    </Box>
  );
};

export default InputLabel;
